import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs-compat';
import { catchError } from 'rxjs/operators';
import { BaseHttpClientService } from './base-http-client.service';

@Injectable()
export class ForgotPasswordService extends BaseHttpClientService  {

  constructor(private http: HttpClient) {
    super()
   }

  public sendUserInfoToResetPassword(body): Observable<any> {
    return (this.http.post(environment.apiUrl + `api/account/reset-password/init`, body) as any)
      .pipe(catchError(this.handleError));
  }

  public sendUserTokenToResetPassword(body): Observable<any> {
    return (this.http.post(environment.apiUrl + `api/account/reset-password/finish`, body) as any)
      .pipe(catchError(this.handleError));
  }

}
